import { Check, Store, Coffee, UtensilsCrossed, Hotel, MapPin } from "lucide-react";
import { Container, Eyebrow, Section, Reveal } from "./common";
import { SELLOS, DESTINOS, TALLERES } from "../data/content";

const ESCUELA_MODULOS = [
  "M1 · Fundamentos EC + marco legal",
  "M2 · Gestión operativa de residuos",
  "M3 · Finanzas circulares",
  "M4 · Comunicación y ciudadanía",
  "M5 · Gobernanza y verificación",
];

const CONVI = [
  "Experto en frutas y verduras — 4 semanas",
  "Ventas consultivas de proximidad",
  "Gestión de mermas y pedidos inteligentes",
  "WhatsApp Business como herramienta de venta",
  "Exhibición y fidelización",
];

const TIPOS = [
  { icon: Store, label: "Mercado" },
  { icon: Coffee, label: "Cafetería" },
  { icon: UtensilsCrossed, label: "Restaurante" },
  { icon: Hotel, label: "Hotel" },
];

export const Formacion = () => {
  return (
    <>
      <Section id="formacion" alt>
        <Container>
          <Reveal>
            <Eyebrow>Formación con aval STPS</Eyebrow>
            <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
              Formamos a quien <span className="text-rc-sage italic">opera</span> y a quien{" "}
              <span className="text-rc-sage italic">vende</span>
            </h2>
          </Reveal>

          <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
            <Reveal>
              <div className="h-full p-8 md:p-10 rounded-2xl bg-rc-card border border-rc-border">
                <div className="rc-eyebrow">Municipios · Gobernanza</div>
                <h3 className="mt-3 font-serif text-2xl text-stone-100">Escuela de Gestores Circulares</h3>
                <p className="mt-3 text-stone-400 font-light leading-relaxed">
                  Cinco módulos de 8 horas que forman al equipo municipal que operará la economía circular
                  desde adentro.
                </p>
                <ul className="mt-6 space-y-2.5">
                  {ESCUELA_MODULOS.map((m) => (
                    <li key={m} className="flex items-start gap-3 text-sm text-stone-300">
                      <Check className="w-4 h-4 text-rc-sage mt-0.5 shrink-0" /><span>{m}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 flex flex-wrap gap-3 text-xs font-mono">
                  <span className="px-3 py-1 rounded-full bg-rc-forest/25 text-rc-sage">40 horas</span>
                  <span className="px-3 py-1 rounded-full bg-rc-bg2 text-stone-400">Constancia DC-3 STPS</span>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="h-full p-8 md:p-10 rounded-2xl bg-rc-card border border-rc-border">
                <div className="rc-eyebrow">Retail · Proximidad</div>
                <h3 className="mt-3 font-serif text-2xl text-stone-100">CONVI Academy</h3>
                <p className="mt-3 text-stone-400 font-light leading-relaxed">
                  Formación especializada para el personal del retail moderno y las tiendas de proximidad.
                  Desde adentro del negocio, para quienes trabajan en él.
                </p>
                <ul className="mt-6 space-y-2.5">
                  {CONVI.map((m) => (
                    <li key={m} className="flex items-start gap-3 text-sm text-stone-300">
                      <Check className="w-4 h-4 text-rc-sage mt-0.5 shrink-0" /><span>{m}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 flex flex-wrap gap-3 text-xs font-mono">
                  <span className="px-3 py-1 rounded-full bg-rc-forest/25 text-rc-sage">Certificación</span>
                  <span className="px-3 py-1 rounded-full bg-rc-bg2 text-stone-400">CONVI Discount · Express &amp; City</span>
                </div>
              </div>
            </Reveal>
          </div>
        </Container>
      </Section>

      <Section id="viva">
        <Container>
          <Reveal>
            <Eyebrow>Turismo territorial</Eyebrow>
            <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
              Raíz <span className="text-rc-sage italic">Viva</span>
            </h2>
            <p className="mt-6 max-w-3xl text-stone-400 font-light leading-relaxed">
              Certificación turística que conecta mercados, cafeterías, restaurantes y hoteles bajo una
              identidad territorial compartida. Cada negocio certificado se integra a la Ruta Raíz Viva.
            </p>
          </Reveal>

          <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
            {SELLOS.map((s, i) => (
              <Reveal key={s.nivel} delay={i * 0.1}>
                <div className="h-full p-8 rounded-2xl bg-rc-card border border-rc-border hover:border-rc-sand/40 transition-all duration-300">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center font-serif text-lg"
                    style={{
                      background: s.nivel === "Oro" ? "#e0a96d" : s.nivel === "Plata" ? "#c9cdc9" : "#c88a51",
                      color: "#0c0f0d",
                    }}
                  >
                    {s.nivel[0]}
                  </div>
                  <h3 className="mt-5 font-serif text-xl text-stone-100">Sello {s.nivel}</h3>
                  <p className="mt-3 text-stone-400 font-light leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-10 flex flex-wrap gap-4">
              {TIPOS.map((t) => (
                <div key={t.label} className="inline-flex items-center gap-2.5 px-5 py-3 rounded-full border border-rc-border bg-rc-bg2 text-stone-300">
                  <t.icon className="w-4 h-4 text-rc-sage" /><span className="text-sm">{t.label}</span>
                </div>
              ))}
            </div>
            <p className="mt-6 text-sm text-stone-500 max-w-2xl font-light">
              Raíz Viva complementa —sin sustituir— los distintivos H, S, M y Tesoros de México del programa
              Pueblos Mágicos de SECTUR.
            </p>
          </Reveal>
        </Container>
      </Section>

      <Section id="destinos" alt>
        <Container>
          <Reveal>
            <Eyebrow>Destinos de referencia</Eyebrow>
            <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
              El oro está en <span className="text-rc-sage italic">el territorio</span>
            </h2>
          </Reveal>
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {DESTINOS.map((d, i) => (
              <Reveal key={d.nombre} delay={(i % 3) * 0.08}>
                <div className="h-full p-7 rounded-2xl bg-rc-card border border-rc-border hover:border-rc-sage/40 transition-all duration-300">
                  <MapPin className="w-5 h-5 text-rc-terra" strokeWidth={1.5} />
                  <h3 className="mt-4 font-serif text-xl text-stone-100">{d.nombre}</h3>
                  <div className="mt-1 text-xs font-mono text-rc-sage uppercase tracking-wider">{d.tag}</div>
                  <p className="mt-3 text-sm text-stone-400 font-light leading-relaxed">{d.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </Section>

      <Section id="talleres">
        <Container>
          <Reveal>
            <Eyebrow>Programas educativos</Eyebrow>
            <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
              Talleres de <span className="text-rc-sage italic">Sostenibilidad</span>
            </h2>
            <p className="mt-6 max-w-2xl text-stone-400 font-light leading-relaxed">
              Programas prácticos basados en 30 años de experiencia real en las principales cadenas de
              autoservicio de México. Sin teoría vacía — con aplicación inmediata.
            </p>
          </Reveal>
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {TALLERES.map((t, i) => (
              <Reveal key={t.n} delay={(i % 3) * 0.08}>
                <div className="h-full p-7 rounded-2xl bg-rc-bg2 border border-rc-border hover:border-rc-sage/40 transition-all duration-300">
                  <div className="font-mono text-sm text-rc-terra tracking-widest">{t.n}</div>
                  <h3 className="mt-4 font-serif text-lg text-stone-100 leading-snug">{t.title}</h3>
                  <p className="mt-3 text-sm text-stone-400 font-light leading-relaxed">{t.text}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {t.tags.map((tag) => (
                      <span key={tag} className="text-xs font-mono px-2.5 py-1 rounded-full bg-rc-card text-stone-400 border border-rc-border">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </Section>
    </>
  );
};
